<template>
  <section
    class="bg-white w-full px-3 py-3"
    style="box-shadow: 0px 4px 30px rgba(72, 80, 112, 0.3)"
  >
    <slot />
  </section>
</template>
